import React from 'react';
import { useTheme, SxProps, Theme } from '@mui/material';
import DSButton from './DSButton';
import { DSTypography } from './Typography';

type DSTabButtonProps = {
  title: string;
  startIcon?: React.ReactNode;
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

const DSTabButton = ({
  title,
  startIcon,
  isSelected = false,
  disabled = false,
  onClick,
  sx,
}: DSTabButtonProps) => {
  const { palette, spacing } = useTheme();

  return (
    <DSButton
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      disableRipple
      sx={{
        ...sx,
        justifyContent: 'center',
        textAlign: 'center',
        gap: spacing(2),
        width: 'auto',
        textTransform: 'none',
        flexShrink: 0,
        minWidth: 'max-content',
        px: spacing(3),
        py: spacing(1.5),
        borderRadius: spacing(12),
        backgroundColor: isSelected
          ? `${palette.white[16]} !important`
          : 'transparent',
        color: isSelected ? palette.text.primary : palette.text.secondary,
        '&:hover': {
          backgroundColor: isSelected
            ? `${palette.white[24]} !important`
            : palette.white[8],
        },
        '&:focus': {
          backgroundColor: isSelected
            ? `${palette.white[16]} !important`
            : 'transparent',
        },
        transition: 'background-color 0.2s ease',
      }}
    >
      <DSTypography
        variant="h6"
        color={disabled ? palette.text.disabled : undefined}
      >
        {title}
      </DSTypography>
    </DSButton>
  );
};

export default DSTabButton;
